<div class="modal-container">
    <div class="action-container">
        <button mat-icon-button (click)="close()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="inner-container">
        @if(!loading){
        <div class="table-container">

            @if (fetchedData != null) {
            @if (fetchedData.overwriteText != null) {
            <p>{{fetchedData.overwriteText}}</p>
            }@else{
            <h3>{{fetchedData.heading}}</h3>

            <table class="general-table">
                <tr>
                    @for (header of fetchedData.columns;track header) {
                    <th>{{header.header}}</th>
                    }
                </tr>

                @for (row of fetchedData.rows; track row) {
                <tr>
                    @for (header of fetchedData.columns;track header) {

                    @if (header.onClick!=null) {
                    <td
                        [style]="(header.styles ?((header.styles.clickable??'')+(header.styles.all??'')):'')+'cursor:pointer;'">
                        <a (click)="header.onClick(row[header.rowKey])">{{row[header.rowKey]}}</a>
                    </td>
                    }@else{
                    <td [style]="header.styles ?((header.styles.unclickable??'')+(header.styles.all??'')):''">
                        <span>{{row[header.rowKey]}}</span>
                    </td>
                    }

                    }
                </tr>
                }
            </table>
            }
            }@else {
            <div class="warning-container">
                <mat-icon>warning</mat-icon>
                <p>No logs were found</p>
            </div>
            }

        </div>
        }@else {
        <div class="loading-container">
            <mat-spinner></mat-spinner>
        </div>
        }
    </div>
</div>